import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import DesignerCard from '../DesignerCard/DesignerCard';
import Loader from '../Loader/Loader';
import arabicImages from '../../assets/images/arabicImages';
import nicheImages from '../../assets/images/nicheImages';
import './DesignerGrid.css';

const DesignerGrid = ({ onSelectDesigner }) => {
  const [designers, setDesigners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const normalize = (s) =>
    String(s || '')
      .toLowerCase()
      .trim()
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ');

  useEffect(() => {
    const fetchDesigners = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'perfumes'));

        const arabicKeys = new Set(Object.keys(arabicImages).map(normalize));
        const nicheKeys = new Set(Object.keys(nicheImages).map(normalize));

        const set = new Set();

        querySnapshot.forEach((doc) => {
          const dRaw = doc.data()?.designer;
          const d = String(dRaw || '').trim();
          if (!d) return;

          const key = normalize(d);

          // ❌ Excluir árabes y nicho del grid de “Diseñador”
          if (arabicKeys.has(key) || nicheKeys.has(key)) return;

          set.add(d);
        });

        const list = Array.from(set).sort((a, b) => a.localeCompare(b, 'es'));
        setDesigners(list);
      } catch (err) {
        console.error('Error fetching designers:', err);
        setError('Error fetching designers');
      } finally {
        setLoading(false);
      }
    };

    fetchDesigners();
  }, []);

  const getImagePath = (designer) => {
    const normalizedDesigner = designer.toLowerCase().replace(/ /g, '_');
    try {
      return require(`../../assets/images/designers/${normalizedDesigner}.png`);
    } catch (err) {
      try {
        return require(`../../assets/images/designers/${normalizedDesigner}.jpg`);
      } catch (err2) {
        return 'https://via.placeholder.com/300x200?text=Designer';
      }
    }
  };

  if (loading) return <Loader message="Cargando diseñadores..." />;
  if (error) return <div className="designer-error">{error}</div>;

  return (
    <div className="designer-grid-wrap">
      <div className="designer-grid">
        {designers.map((designer) => (
          <DesignerCard
            key={normalize(designer)}
            designer={designer}
            image={getImagePath(designer)}
            onClick={() => onSelectDesigner(designer)}
          />
        ))}
      </div>
    </div>
  );
};

export default DesignerGrid;
